import React from 'react';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import TabActions from '@/components/tabs/TabActions';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const WorkspaceRequestCompleteActions = ({ code, compact, goBack }) => {
  const { saveStatus } = Selectors.useWorkspaceRequestCompleteActions({ code });
  const onClose = Events.useDestroyRequestWorkspace({ code });

  return (
    <TabActions className="aridhia-workspace-request-wizard-actions">
      {(saveStatus === states.ERROR) && (
        <>
          <BackButton onClick={goBack} iconOnly={compact} />
          <CloseButton onClick={onClose} messageId="actions.close" />
        </>
      )}
      {(saveStatus !== states.ERROR) && (
        <CloseButton disabled={saveStatus === states.PENDING} messageId="actions.finish" onClick={onClose} />
      )}
    </TabActions>
  );
};

export default WorkspaceRequestCompleteActions;
